/* eslint-disable react/no-array-index-key */
import React, { PureComponent } from 'react';
import { Row, Col, Container, Button } from 'reactstrap';
import PropTypes from 'prop-types';
import {Link, withRouter} from 'react-router-dom';
import * as environment from '../../../modules/environment';
import {connect} from "react-redux";
//import Button from '@material-ui/core/Button';
import * as TextManager from "../../../modules/languages/TextManager";



class SalesItems extends PureComponent {
    static propTypes = {
        items: PropTypes.arrayOf(PropTypes.shape({
            src: PropTypes.string,
            title: PropTypes.string,
            price: PropTypes.string,
            description: PropTypes.string,
            colors: PropTypes.arrayOf(PropTypes.string),
            new: PropTypes.bool,
        })),
    };

    static defaultProps = {
        items: [],
    };

    render() {

        let userType = undefined;
        let isMangerCellular = false;
        let isMangerCellular012 = false;
        let isMangerTvOtInternet = false;
        let iManagerInternet018 = false;
        let isAdmin = false;
        let isStore = false;

        if(this.props.userData && this.props.userData.data && this.props.userData.data.userType !== undefined){
            userType = this.props.userData.data.userType;
            isMangerCellular = userType !== undefined && userType === environment.ListUserTypesEnum.ManagerCellular;
            isMangerTvOtInternet = userType !== undefined && userType === environment.ListUserTypesEnum.ManagerTVOrInternet;
            isAdmin = this.props.userData.data.isAdmin;
            isStore = userType === environment.ListUserTypesEnum.Store;

            isMangerCellular012 = userType !== undefined && userType === environment.ListUserTypesEnum.ManagerCellular012;

            iManagerInternet018 = userType !== undefined && userType === environment.ListUserTypesEnum.ManagerInternet018;
        }

        //console.log(this.props.items);

        let internet = this.props.items.filter(a => a.providerType === 3);
        let cellular = this.props.items.filter(a => a.providerType === 1);
        let tv = this.props.items.filter(a => a.providerType === 2);
        let cellularKasher = this.props.items.filter(a => a.providerType === 4);
        let cellular012Partner = this.props.items.filter(a => (a.id === 3 || a.id === 7)); // 012 and partner
        let partnerTv = this.props.items.find(a => a.id === 13);
        let partnerInet = this.props.items.find(a => a.id === 18);
        let inet018 = this.props.items.find(a => a.id === 24);

        let isAllSims = false;
        if(TextManager.getCurrentDashboard() === 'allsim') {
            isAllSims = true;

            cellular = cellular.filter(a => a.id === 9 || a.id === 4 || a.id === 5 || a.id === 2 || a.id === 6); // Pelephone, Golan, Walla, We, Cellcom
            cellularKasher = cellularKasher.filter(a => a.id === 25 || a.id === 28 || a.id === 27); // Golan Kasher, Pelephone Kasher, Cellcom Kasher
        }

        //console.log(cellular);

        return (
            <Container className="catalog-items__wrap">
                {/*Cellular Regular + 012*/}
                {cellular && cellular.length > 0 && (isAdmin || isMangerCellular || isStore || isMangerCellular012) &&<Row style={{ fontSize: '30px'}}>סלולר רגיל</Row>}
                {cellular && cellular.length > 0 && (isAdmin || isMangerCellular || isStore) &&<Row>
                    <div className="catalog-items">
                        {cellular.filter(a => a.providerType === 1).map((item, i) =>
                            (

                                <Col xs={5} md={1} className="catalog-item" key={i} style={{ marginBottom: '5px', marginRight: '3px', marginLeft: '3px' }}>
                                    <Link className="catalog-item__link" to={{ pathname: `/sales/${item.id}`, state: { name: item.name, id: item.id, type: 1}}}>
                                        <div className="catalog-item__info">
                                            <h5 className="catalog-item__title" style={{fontWeight: 'bold', textAlign: 'center'}}>{item.name}</h5>
                                        </div>
                                        <div className="catalog-item__img-wrap">
                                            <img className="catalog-item__img" style={{objectFit: 'contain'}}
                                                 src={environment.getServerBasePath() + '/providers/download?providerID=' + item.id} alt="catalog-item-img" />
                                        </div>
                                    </Link>
                                </Col>

                            ))}
                    </div>
                </Row>}

                {/*cellular && cellular.length > 0 && (isAdmin || isMangerCellular || isStore) &&<Row>
                    <div className="catalog-items">
                        {this.props.items.filter(a => a.providerType === 1).map((item, i) =>
                            (

                                <Col xs={5} md={1} key={i} style={{ marginBottom: '5px', marginRight: '3px', marginLeft: '3px' }}>
                                    <Button color='primary' size='sm' style={{ whiteSpace: 'normal', fontSize: '12px'}}
                                            onClick={(e) => {
                                                e.preventDefault();
                                                window.open(item.link, '_blank');
                                            }}>{item.link_text}</Button>
                                </Col>

                            ))}
                    </div>
                </Row>*/}

                {cellular012Partner && (isMangerCellular012) &&<Row>
                    <div className="catalog-items">
                        {cellular012Partner.map((item, i) =>
                        <Col xs={5} md={1} className="catalog-item" key={i} style={{ marginBottom: '5px', marginRight: '3px', marginLeft: '3px' }}>
                            <Link className="catalog-item__link" to={{ pathname: `/sales/${item.id}`, state: { name: item.name, id: item.id, type: 1}}}>
                                <div className="catalog-item__img-wrap">
                                    <img className="catalog-item__img" style={{objectFit: 'contain'}}
                                         src={environment.getServerBasePath() + '/providers/download?providerID=' + item.id} alt="catalog-item-img" />
                                </div>
                            </Link>
                        </Col>
                        )}
                    </div>
                </Row>}

                {/*Cellular Kasher*/}
                {cellularKasher && cellularKasher.length > 0 && (isAdmin || isMangerCellular || isStore) &&<Row style={{ fontSize: '30px'}}>סלולר כשר</Row>}
                {cellularKasher && cellularKasher.length > 0 && (isAdmin || isMangerCellular || isStore) &&<Row>
                    <div className="catalog-items">
                        {cellularKasher.filter(a => a.providerType === 4).map((item, i) =>
                            (

                                <Col xs={5} md={1} className="catalog-item" key={i} style={{ marginBottom: '5px', marginRight: '3px', marginLeft: '3px' }}>
                                    <Link className="catalog-item__link" to={{ pathname: `/sales/${item.id}`, state: { name: item.name, id: item.id, type: 1}}}>
                                        <div className="catalog-item__info">
                                            <h5 className="catalog-item__title" style={{fontWeight: 'bold', textAlign: 'center'}}>{item.name}</h5>
                                        </div>
                                        <div className="catalog-item__img-wrap">
                                            <img className="catalog-item__img" style={{objectFit: 'contain'}}
                                                 src={environment.getServerBasePath() + '/providers/download?providerID=' + item.id} alt="catalog-item-img" />
                                        </div>
                                    </Link>
                                </Col>

                            ))}
                    </div>
                </Row>}

                {/*cellularKasher && cellularKasher.length > 0 && (isAdmin || isMangerCellular || isStore) &&<Row>
                    <div className="catalog-items">
                        {this.props.items.filter(a => a.providerType === 4).map((item, i) =>
                            (

                                <Col xs={5} md={1} key={i} style={{ marginBottom: '5px', marginRight: '3px', marginLeft: '3px' }}>
                                    <Button color='primary' size='sm' style={{ whiteSpace: 'normal', fontSize: '12px'}}
                                            onClick={(e) => {
                                                e.preventDefault();
                                                window.open(item.link, '_blank');
                                            }}>{item.link_text}</Button>
                                </Col>

                            ))}
                    </div>
                </Row>*/}



                {!isAllSims && tv && tv.length > 0 && (isStore || isAdmin || isMangerTvOtInternet || isMangerCellular012) &&<Row style={{ fontSize: '30px'}}>טלויזיה</Row>}
                {!isAllSims && tv && tv.length > 0 && (isStore || isAdmin || isMangerTvOtInternet) &&<Row>

                <div className="catalog-items">
                        {this.props.items.filter(a => a.providerType === 2).map((item, i) =>
                            (
                                <Col xs={5} md={1} className="catalog-item" key={i} style={{ marginBottom: '5px', marginRight: '3px', marginLeft: '3px' }}>
                                    <Link className="catalog-item__link" to={{ pathname: `/sales/2/${item.id}`, state: { name: item.name, id: item.id, type: 2}}}>
                                        <div className="catalog-item__img-wrap">
                                            <img className="catalog-item__img" style={{objectFit: 'contain'}}
                                                 src={environment.getServerBasePath() + '/providers/download?providerID=' + item.id} alt="catalog-item-img" />
                                        </div>
                                        {/*<div className="catalog-item__info">
                                            <h5 className="catalog-item__title" onClick={(e) => {
                                                e.preventDefault();
                                                window.open(item.link, '_blank');
                                            }}>פירוט מבצעים</h5>
                                        </div>*/}
                                    </Link>
                                </Col>
                            ))}
                    </div>
                </Row>}
                {/*tv && tv.length > 0 && (isStore || isAdmin || isMangerTvOtInternet) &&<Row>

                    <div className="catalog-items">
                        {this.props.items.filter(a => a.providerType === 2).map((item, i) =>
                            (
                                <Col xs={5} md={1} key={i} style={{ marginBottom: '5px', marginRight: '3px', marginLeft: '3px' }}>
                                    <Button color='primary' size='sm' style={{ whiteSpace: 'normal', fontSize: '12px'}}
                                            onClick={(e) => {
                                                e.preventDefault();
                                                window.open(item.link, '_blank');
                                            }}>{item.link_text}</Button>
                                </Col>
                            ))}
                    </div>
                </Row>*/}

                {!isAllSims && partnerTv && (isMangerCellular012) &&<Row>
                    <div className="catalog-items">
                        <Col xs={5} md={1} className="catalog-item" key={"partnerTv"} style={{ marginBottom: '5px', marginRight: '3px', marginLeft: '3px' }}>
                            <Link className="catalog-item__link" to={{ pathname: `/sales/${partnerTv.id}`, state: { name: partnerTv.name, id: partnerTv.id, type: 2}}}>
                                <div className="catalog-item__img-wrap">
                                    <img className="catalog-item__img" style={{objectFit: 'contain'}}
                                         src={environment.getServerBasePath() + '/providers/download?providerID=' + partnerTv.id} alt="catalog-item-img" />
                                </div>
                                {/*<div className="catalog-item__info">*/}
                                {/*<h5 className="catalog-item__title">{item.name}</h5>*/}
                                {/*</div>*/}
                            </Link>
                        </Col>
                    </div>
                </Row>}

                {!isAllSims && internet && internet.length > 0 && (isStore || isAdmin || isMangerTvOtInternet || isMangerCellular012 || iManagerInternet018) &&<Row style={{ fontSize: '30px'}}>אינטרנט</Row>}
                {!isAllSims && internet && internet.length > 0 && (isStore || isAdmin || isMangerTvOtInternet) &&<Row>
                    <div className="catalog-items">
                        {this.props.items.filter(a => a.providerType === 3).map((item, i) =>
                            (
                                <Col xs={5} md={1} className="catalog-item" key={i} style={{ marginBottom: '5px', marginRight: '3px', marginLeft: '3px'}}>
                                    <Link className="catalog-item__link" to={{ pathname: `/sales/3/${item.id}`, state: { name: item.name, id: item.id, type: 3}}}>
                                        <div className="catalog-item__img-wrap">
                                            <img className="catalog-item__img" style={{objectFit: 'contain'}}
                                                 src={environment.getServerBasePath() + '/providers/download?providerID=' + item.id} alt="catalog-item-img" />
                                        </div>
                                        {/*<div className="catalog-item__info">
                                            <h5 className="catalog-item__title" onClick={(e) => {
                                                e.preventDefault();
                                                window.open(item.link, '_blank');
                                            }}>פירוט מבצעים</h5>
                                        </div>*/}
                                    </Link>
                                </Col>
                            ))}
                    </div>
                </Row>}
                {/*internet && internet.length > 0 && (isStore || isAdmin || isMangerTvOtInternet) &&<Row>
                    <div className="catalog-items">
                        {this.props.items.filter(a => a.providerType === 3).map((item, i) =>
                            (
                                <Col xs={5} md={1} key={i} style={{ marginBottom: '5px', marginRight: '3px', marginLeft: '3px' }}>
                                    <Button color='primary' size='sm' style={{ whiteSpace: 'normal', fontSize: '12px'}}
                                            onClick={(e) => {
                                                e.preventDefault();
                                                window.open(item.link, '_blank');
                                            }}>{item.link_text}</Button>
                                </Col>
                            ))}
                    </div>
                </Row>*/}

                {!isAllSims && partnerInet && (isMangerCellular012) &&<Row>
                    <div className="catalog-items">
                        <Col xs={5} md={1} className="catalog-item" key={"partnerInet"} style={{ marginBottom: '5px', marginRight: '3px', marginLeft: '3px' }}>
                            <Link className="catalog-item__link" to={{ pathname: `/sales/${partnerInet.id}`, state: { name: partnerInet.name, id: partnerInet.id, type: 3}}}>
                                <div className="catalog-item__img-wrap">
                                    <img className="catalog-item__img" style={{objectFit: 'contain'}}
                                         src={environment.getServerBasePath() + '/providers/download?providerID=' + partnerInet.id} alt="catalog-item-img" />
                                </div>
                                {/*<div className="catalog-item__info">*/}
                                {/*<h5 className="catalog-item__title">{item.name}</h5>*/}
                                {/*</div>*/}
                            </Link>
                        </Col>
                    </div>
                </Row>}

                {!isAllSims && inet018 && (iManagerInternet018) &&<Row>
                    <div className="catalog-items">
                        <Col xs={5} md={1} className="catalog-item" key={"inet018"} style={{ marginBottom: '5px', marginRight: '3px', marginLeft: '3px' }}>
                            <Link className="catalog-item__link" to={{ pathname: `/sales/${inet018.id}`, state: { name: inet018.name, id: inet018.id, type: 3}}}>
                                <div className="catalog-item__img-wrap">
                                    <img className="catalog-item__img" style={{objectFit: 'contain'}}
                                         src={environment.getServerBasePath() + '/providers/download?providerID=' + inet018.id} alt="catalog-item-img" />
                                </div>
                                {/*<div className="catalog-item__info">*/}
                                {/*<h5 className="catalog-item__title">{item.name}</h5>*/}
                                {/*</div>*/}
                            </Link>
                        </Col>
                    </div>
                </Row>}

            </Container>
        );
    }
}


const mapStateToProps = (state) => {
    return {
        userData: state.userData
    };
};

export default withRouter(connect(mapStateToProps)(SalesItems))
